import styled from 'styled-components';

export const Container = styled.div`
  .tasks {
    background: rgba(32, 32, 32, 1);
    border-radius: 25px;
  }

  .min-height {
    min-height: 100px;
  }

  .skeleton {
    background-color: #343434 !important;
    overflow: hidden;
    position: relative;
    border-radius: 20px;
    border: none !important;
    color: transparent !important;
    pointer-events: none;
    display: block;
    box-shadow: none;

    span,
    input {
      color: transparent !important;
    }
    img {
      display: none;
    }

    button {
      display: none;
    }

    :after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      transform: translateX(-100%);
      background: linear-gradient(
        90deg,
        #343434 0%,
        rgba(24, 26, 26, 0) 0%,
        rgba(24, 26, 26, 0) 10%,
        rgba(24, 26, 26, 0.2) 20%,
        rgba(24, 26, 26, 0.5) 40%,
        rgba(24, 26, 26, 0.8) 50%,
        rgba(24, 26, 26, 0.2) 80%,
        rgba(24, 26, 26, 0) 90%,
        rgba(24, 26, 26, 0) 100%
      ) !important;
      animation: glow 1.3s linear infinite;
    }

    @keyframes glow {
      100% {
        transform: translateX(100%);
      }
    }
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .bg-gray ol li {
      border-color: transparent !important;
    }
    ol {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      max-height: 260px;
      overflow: hidden;
      li {
        .border-bottom {
          border-bottom: none;
        }
      }
    }
  }
  @media screen and (min-width: 1400px) {
    .h-xxl-300 {
      height: 300px;
    }
  }
`;

export const AllCourses = styled.div``;

export const Welcome = styled.div`
  h1 {
    color: #e4e4e4;
  }

  p {
    color: #969696;
  }

  .btn-month {
    background: #242526;
    border: 1px solid rgba(225, 225, 225, 0.2);

    span {
      color: #8c8c8c;
    }
  }
`;

export const CoachAndAffiliate = styled.div`
  @media screen and (max-width: 991px) {
    .w-650 {
      width: 650px;
    }
  }
`;

export const Content = styled.div`
  background: #202020;
  border-radius: 20px;
  padding: 20px;

  .title-chart {
    h3,
    p {
      color: #cbccce;
    }
  }

  .btn-month {
    background: #242526;
    border: 1px solid rgba(225, 225, 225, 0.2);

    span {
      color: #8c8c8c;
    }
  }

  .bg-gray {
    background: #242526;
    border-radius: 20px;
    padding: 10px 20px;

    h3,
    p {
      color: #cbccce;
    }

    li {
      border-color: #474848 !important;
    }
  }

  .icons {
    width: 30px;
    height: 30px;
  }

  p.text-green {
    color: #37c694;
  }

  p.text-red {
    color: #ff1a50;
  }

  .avatar-coach {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  @media screen and (max-width: 575px) {
    .bg-gray {
      height: 110px;
    }
  }
`;

export const Graph = styled.div`
  background: #242526;
  border-radius: 20px;
  padding: 20px;
`;

export const TopCoach = styled.div`
  background: #202020;
  border-radius: 20px;

  .avatar {
    width: 90px;
    height: 90px;
    padding: 3px;
    background-image: linear-gradient(0deg, #202020, #202020),
      linear-gradient(180deg, #825511 0%, #f3bf5c 100%);
    background-origin: border-box;
    background-clip: content-box, border-box;
    border-image-slice: 1;
    border-radius: 50%;
  }
`;

export const TopAfiliate = styled.div`
  background: #202020;
  border-radius: 20px;

  .btn-month {
    background: #242526;
    border: 1px solid rgba(225, 225, 225, 0.2);

    span {
      color: #8c8c8c;
    }
  }

  .avatar {
    width: 90px;
    height: 90px;
    padding: 3px;
    background-image: linear-gradient(0deg, #202020, #202020),
      linear-gradient(180deg, #825511 0%, #f3bf5c 100%);
    background-origin: border-box;
    background-clip: content-box, border-box;
    border-image-slice: 1;
    border-radius: 50%;
  }
`;
